import { useMutation, useQueryClient } from "@tanstack/react-query";
import * as Sentry from "@sentry/react";
import toast from "react-hot-toast";
import { supabase } from "../../lib/supabase";
import { invalidateSharingQueries } from "../../lib/invalidateSharing";

// Unshare (CONTEXT.md): an Owner ending sharing entirely. Every Member and
// every unanswered Invitation is deleted in one call; the List itself
// becomes an ordinary private List again. list_members' DELETE policy lets
// the Owner remove any row on a List they own, so this is a plain bulk
// delete rather than a database function.
export function useUnshareList() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (listId: string): Promise<void> => {
      const { error } = await supabase.from("list_members").delete().eq("list_id", listId);
      if (error) throw error;
    },

    onSuccess: (_result, listId) => {
      invalidateSharingQueries(queryClient, listId);
    },

    onError: (err) => {
      Sentry.captureException(err, { extra: { mutation: "useUnshareList" } });
      toast.error("Couldn't stop sharing that list. Please try again.");
    },
  });
}
